import React from 'react';
import {
  Box,
  StackLayout,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { Route, Routes } from '@leagueplatform/routing';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { MasonryPageContainer } from 'pages/masonry/masonry-container.page';
import { LegalSidebar } from './legal-sidebar/legal-sidebar.component';
import { LegalContent } from './legal-content-container/legal-content.component';

type LegalPageContainerProps = {
  children: React.ReactNode;
};

function LegalPageContainer({ children }: LegalPageContainerProps) {
  return (
    <Box css={{ overflowX: 'hidden', position: 'relative' }}>{children}</Box>
  );
}

export const LegalPage = () => {
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));

  if (isMobile) {
    return (
      <MasonryPageContainer>
        <Routes>
          <Route index element={<LegalSidebar />} />
          <Route
            path={`${APP_MANAGED_ROUTES.LEGAL_DETAILS_SUBPATH}/*`}
            element={<LegalContent />}
          />
        </Routes>
      </MasonryPageContainer>
    );
  }

  return (
    <LegalPageContainer>
      <MasonryPageContainer>
        <StackLayout
          orientation="horizontal"
          spacing={{ '@desktop': '$two' }}
          horizontalAlignment="spaceBetween"
        >
          <LegalSidebar />
          <Routes>
            <Route
              path={`${APP_MANAGED_ROUTES.LEGAL_DETAILS_SUBPATH}/*`}
              element={<LegalContent />}
            />
          </Routes>
        </StackLayout>
      </MasonryPageContainer>
    </LegalPageContainer>
  );
};
